import { Tooltip } from "antd"
import { pencil_img } from "../../assets/images"
import { useHistory } from "react-router-dom"
import MisApi from "../../services/mis.api"
import { successOrFailureToaster } from "../../components/common/atoms/messages"

/** User-facing label for MIS pulse_type (matches AddMisPulse pulse types + legacy). */
export const pulseTypeDisplayName = (pulseType) => {
  if (pulseType == null || pulseType === '') return ''
  const map = {
    opd: 'OPD',
    opd_v2: 'OPD',
    utilization: 'Utilization',
    utilization_v2: 'Utilization',
    opd_utilization: 'Both'
  }
  return map[pulseType] ?? String(pulseType)
}

const misPulseSchema = ({data, setRefresh}) => {
  const history = useHistory()

  const deactivateMisPulse = () => {
    MisApi.deactivateMisPulse(
      { id: data.id },
      (res) => {
        successOrFailureToaster({ message: 'MIS Pulse deactivated successfully' });
        history.push('/mis-pulse');
        setRefresh(true);
      },
      (err) => {
        const data = err?.response?.data
        const msg = data?.message || data?.msg || data?.error || err?.message || 'Operation failed'
        successOrFailureToaster({ message: msg, type: 'fail' });
      }
    );
  }

  const activateMisPulse = () => {
    MisApi.activateMisPulse(
      { id: data.id },
      (res) => {
        successOrFailureToaster({ message: 'MIS Pulse activated successfully' });
        history.push('/mis-pulse');
        setRefresh(true);
      },
      (err) => {
        const data = err?.response?.data
        const msg = data?.message || data?.msg || data?.error || err?.message || 'Operation failed'
        successOrFailureToaster({ message: msg, type: 'fail' });
      }
    );
  }

  const canTrigger = ['CSM', 'CSMMaster'].includes(sessionStorage.getItem('role'))

  const triggerMisPulse = () => {
    MisApi.triggerMisPulse(
      { id: data.id },
      (res) => { successOrFailureToaster({ message: 'MIS report generation triggered' }); },
      (err) => { successOrFailureToaster({ message: 'Operation failed', type: 'error' }); }
    );
  }

  const formatToCommaSeparated = (array) => {
    if (!Array.isArray(array) || array.length === 0) return "";
    let fullText = array.join(", ");
    const maxLength = 70;
    return fullText.length > maxLength ? fullText.slice(0, maxLength) + "..." : fullText;
  };

  const formatMappings = (array) => formatToCommaSeparated(array) || '-'

  const formatCompanies = (companies, sids) => {
    if (Array.isArray(companies) && companies.length) {
      return formatToCommaSeparated(companies.map((c) => `${c.name} (${c.id})`))
    }
    return formatToCommaSeparated(sids) || '-'
  }

  const editMis = ()=>{
    history.push({pathname : 'mis-pulse/add', state : {data : data}})
  }

  return (
    <tr className='text-gray-600' key={data.id} >
      <td className={`pl-3 py-4 w-8`}>{data.id}</td>
      <td className={`pl-3 pr-4 py-4 w-1/6 break-words`}>{data.name || '-'}</td>
      <td className={`pl-3 py-4 w-8 break-words `}>
          {data.frequency}
      </td>
      <td className={`pl-3 pr-4 py-4 w-8`}>{pulseTypeDisplayName(data.pulse_type)}</td>
       <td className={`pl-3 pr-4 py-4 w-1/4`}>{formatToCommaSeparated(data.benefits)}</td>
       <td className={`pl-3 pr-4 py-4 w-1/4`}>{formatCompanies(data.companies, data.sids)}</td>
       <td className={`pl-3 pr-4 py-4 w-1/4 break-words `}>
        {formatMappings(data.mappings)}
       </td>
       <td className={`pl-3 pr-4 py-4 w-1/4 break-words `}>
        {formatMappings(data.opd_mappings)}
       </td>
       <td className='py-3 px-3 w-44'>
         <div className="flex items-center gap-1">
           { (data.status === 'active' || data.status === 'inactive') &&
             <Tooltip placement='bottom' title='Edit mis pulse'>
               <button onClick={editMis} className='px-2.5 py-1 text-xs font-medium text-gray-500 hover:bg-gray-100 rounded whitespace-nowrap cursor-pointer inline-flex items-center gap-1'>
                 <img src={pencil_img} style={{width: '14px', height: '14px'}} />
                 Edit
               </button>
             </Tooltip>
           }
           { (data.status === 'draft' || data.status === 'inactive') &&
             <Tooltip placement='bottomRight' title='Activate'>
               <button onClick={activateMisPulse} className='px-2.5 py-1 text-xs font-medium text-blue-600 hover:bg-blue-50 rounded whitespace-nowrap cursor-pointer'>
                 Activate
               </button>
             </Tooltip>
           }
           { data.status === 'active' &&
             <Tooltip placement='bottomRight' title='Deactivate'>
               <button onClick={deactivateMisPulse} className='px-2.5 py-1 text-xs font-medium text-blue-600 hover:bg-blue-50 rounded whitespace-nowrap cursor-pointer'>
                 Deactivate
               </button>
             </Tooltip>
           }
           { canTrigger &&
             <Tooltip placement='bottomRight' title='Send MIS report now'>
               <button onClick={triggerMisPulse} className='px-2.5 py-1 text-xs font-medium text-white bg-blue-600 hover:bg-blue-700 rounded whitespace-nowrap cursor-pointer'>
                 Trigger
               </button>
             </Tooltip>
           }
         </div>
       </td>
    </tr>
  )
}

export default misPulseSchema
